<template>
    <div v-if="cargando">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3> 
            </div>
        </div>
    </div>
    <div v-else>
    <br>
    <b-row>
        <b-col md="2">
            <b-form-group horizontal label="Orden" class="mb-0">
                <b-input-group>
                <b-form-select v-model="orden" slot="append" @input="listDebitNote">
                    <option :value="'asc'">Mas Antiguo</option>
                    <option :value="'desc'">Mas Reciente</option>
                </b-form-select>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col cols="1" sm="2"	md="2"	lg="2"	xl="3">
            <b-form inline>
                Desde: <b-input type="date" v-model="f1"/>
                Hasta: <b-input type="date" v-model="f2"/>
            </b-form>
        </b-col>
        <b-col>
          <b-button @click="listDebitNote" variant="success">Buscar</b-button>
        </b-col>
        <b-col md="2">
            <div class="col-md-12 text-center">
                <b-button variant="secondary" @click="listDebitNote"><i class="fa fa-sync-alt"></i> </b-button>
            </div>
        </b-col>
        <b-col md="2">
            <b-form-group horizontal label="Mostrar" class="mb-0">
                <b-input-group>
                    <b-form-select v-model="limite" slot="append" @input="listDebitNote">
                    <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </b-form-select>                            
                </b-input-group>                        
            </b-form-group>                    
        </b-col>
    </b-row>
    <br>
    <b-table
         
        striped hover :items="debitnotes" :fields="debitnotes_fields"
        >
        <template slot="estado" slot-scope="data">
            <template v-if="data.item.emitido==1 && data.item.baja==1">
                <div><span class="badge badge-dark">Baja <i class="fa fa-ban"></i></span></div>
            </template>
            <template v-else-if="data.item.emitido==3 && data.item.baja==0">
                <div><span class="badge badge-info">Baja pendiente <i class="fa fa-ban"></i></span></div>
            </template>
            <template v-else>
                <div v-if="data.item.emitido==1"><span class="badge badge-success">Emitido <i class="fa fa-check"></i></span></div>
                <div v-else-if="data.item.emitido==0"><span class="badge badge-warning" title="Las boletas se evian al final del día">Por Enviar <i class="fa fa-hourglass-half"></i></span></div>
                <div v-else-if="data.item.emitido==2"><span class="badge badge-danger">Rechazado <i class="fa fa-times"></i></span></div>
            </template>
        </template>
        <template slot="receptor" slot-scope="data">
            <template v-if="data.item.receiver">
                {{data.item.idReceptor}} - {{data.item.receiver.razonSocial}}
            </template>
            <template v-else>
                {{ data.item.idReceptor }}
            </template>            
        </template>
        <template slot="emision" slot-scope="data">
            <template v-if="data.item.fechaEmision !== '0000-00-00 00:00:00'">
                {{ data.item.fechaEmision | moment('D/M/Y hh:mm:ss A') }} 
            </template>
            <template v-else>
                -
            </template>            
        </template>
        <template slot="moneda" slot-scope="data">
            <template v-if="data.item.tipoMoneda=='PEN'">S/</template>
            <template v-else-if="data.item.tipoMoneda=='USD'">$</template>
            <template v-else>{{ data.item.tipoMoneda }}</template>                     
            {{data.item.importeTotal}}
        </template>
        <template slot="acciones" slot-scope="data">
            <template v-if="data.item.emitido!=2">
                <b-button-group>
                    <b-button v-b-tooltip.hover v-b-modal.modalprevnc title="Vista Previa" @click="viewPdf(data.item)"><i class="fa fa-television"></i></b-button>
                    <b-button @click="downloadPdf(data.item)" v-b-tooltip.hover title="Descargar PDF"><i class="fa fa-file-pdf-o"></i></b-button>                        
                    <b-button @click="setNote(data.item)" v-b-modal.modalsendnc v-b-tooltip.hover title="Enviar por Mail"><i class="fa fa-envelope-o"></i></b-button>                      
                    <b-button v-if="data.item.emitido==0" title="Descargar CDR" class="disabled" :disabled="true"><i class="fa fa-file-zip-o"></i></b-button>
                    <b-button v-else @click="downloadCdr(data.item)" title="Descargar CDR"><i class="fa fa-file-zip-o"></i></b-button>
                    <b-button v-if="data.item.emitido==0" class="disabled" :disabled="true" v-b-tooltip.hover title="Descargar XML"><i class="fa fa-file-code-o"></i></b-button>
                    <b-button v-else @click="downloadXml(data.item)" v-b-tooltip.hover title="Descargar XML"><i class="fa fa-file-code-o"></i></b-button>
                </b-button-group>                      
            </template>
            <template v-else>
                <b-button-group>
                    <b-button @click="downloadCdr(data.item)" title="Descargar CDR"><i class="fa fa-file-archive"></i></b-button>
                    <b-button v-if="data.item.emitido==2" @click="estadoEmision(data.item)" v-b-modal.motivorechazo6 v-b-tooltip.hover title="Estado de la emision" class="btn" variant = "primary"><i class="fa fa-eye text-white"></i></b-button>
                </b-button-group>
            </template>
        </template>           
    </b-table>
    <b-modal v-model="modalsendnc"  id="modalsendnc" title="Enviar por Correo">
        <div role="group">
        <label for="inputLive">Correos:</label>
        <b-form-input v-model="recipients" type="email" @keyup.enter="sendMail(note)" class="input-requierido"></b-form-input>
        <p class="input-requerido">Ingresa un correo ó varios separados por comas (,)</p>
        </div>
            <div slot="modal-footer" class="w-100">
            <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="sendMail(note)">
            Enviar
            </b-btn>
            <b-btn v-else size="sm" class="float-right" variant="secondary">
            <i class="fa fa-spin fa-spinner"></i> Enviando... 
            </b-btn>
        </div>
    </b-modal>            
    <b-modal id="motivorechazo6" title="Motivo del Rechazo" v-model="motivoRechazo">
        <div role="group">
            <div v-if="spinoff">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h6>{{ descripcionRechazo }}</h6>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100">
            <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="motivoRechazo=!motivoRechazo">
                Ok
            </b-btn>
        </div>
    </b-modal>
    <b-modal id="modalprevnc" size="lg" title="Vista Previa" cancel-title="Cerrar">
        <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
        <template v-else>
            <template v-if="pdfobject !==''">
            <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
            </template>
        </template>                
    </b-modal>
    <div class="row">
        <div class="col-md-9">
            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
        </div>
        <div class="col-md-3">
            <b-pagination size="md" :total-rows="total" v-model.number="pactual" :per-page="limite" @input="listDebitNote"></b-pagination>
        </div>
    </div>
    <vue-snotify></vue-snotify>
</div>
</template>

<script>
const config = {
       headers: {
            'Content-type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin':'*',
            'Access-Control-Allow-Methods': 'POST',
            'Access-Control-Allow-Headers':'*',
            'cache-control': 'no-cache'
          }
}
import axios from 'axios'
import download from 'downloadjs'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { EspecificacionIgvTipo1 } from '@/shared/utils'
import { EspecificacionIgvTipo2 } from '@/shared/utils'
export default {
    name: 'NotaDebitoBoletaConsulta',
    components: {
        Datepicker
    },
    data: () => {
        return {
            motivoRechazo: false,
            spinoff: false,
            descripcionRechazo: '',
            modalInfo: { holi1: 'holi', holi2: 'holi2' },
            itemAlterado: false,
            montoActual: '',
            montoDescuento: '',
            fieldsNC: ['cantidad', 'descripcion', 'valorUnitario', 'valorVenta', 'actions', 'acciones'],
            invoice: [],
            listaNotaCredito: [],
            listaNotaCreditoAfectada: [],
            descuentoItemSiguiente: false,
            generalesNC: false,
            especificacionIgv1: EspecificacionIgvTipo1,
            especificacionIgv2: EspecificacionIgvTipo2,
            modalsendnc: false,
            especificacionIgv: '01',
            afectacionIgv: '01',
            monto: '',
            igv: '',
            currentdate: '',
            es: es,
            femision: '',
            hemision: '',
            emisioncreditnote: false,
            previanotacredito: false,
            previacorreo: false,
            sendcorreo: false,
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            cargando: false,
            pactual: 1,
            limite: 10,
            orden: 'desc',
            recipients: '',     
            listaafectacion: [
                {
                    id: '02',
                    descripcion: 'Inafecto'
                },
                {
                    id: '01',
                    descripcion: 'Gravado'
                },
                {
                    id: '03',
                    descripcion: 'Exonerado'
                },
                {
                    id: '04',
                    descripcion: 'Exportación'
                }
            ],
            Especificacion: [],
            especificacion:{
                codigo: '10',
                descripcion: 'Operacion onerosa',
                codigoTributo: '1000'
            },
            debitnotes: [],
            debitnotes_fields: [
                {key: 'serie', label: 'Serie', sortable: true},
                {key: 'numero', label: 'Numero', sortable: true},
                {key: 'emision', label: 'Emision', sortable: true},
                {key: 'receptor', label: 'Receptor', sortable: true},
                {key: 'moneda', label: 'Total Gravado', sortable: true},
                {key: 'estado', label: 'Estado', sortable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            note: {},
            items: [],
            serieAfectada: '',
            checkSerieAfectada: false,
            responseSerieAfectado: '',
            numeroAfectado: '',
            checkNumeroAfectado: false,
            responseNumeroAfectado: '',
            serieNC: '',
            checkSerieNC: false,
            responseSerieNC: '',
            descripcionNC: '',
            checkDescripcionNC: false,
            responseDescripcionNC: '',
            pdfobject: '',
            cargandopdf: false,
            cargandopdf2: false,
            checkserie: false,
            checknumero: false,
            diasnopermitidos: {
            ranges: []
            },
            tiponotacredito: '01',
            f1:'',
            f2:'',
        }
    },
    mounted () {
        this.listDebitNote()
    },
    methods: {
        listDebitNote: function () {
            let dia1;
            let dia2;
            if(this.f1 === "" && this.f2 ===""){
                dia1 =  ""
                dia2 = ""
            }else{
                dia1 = this.$moment(this.f1).format('YYYY-MM-DD HH:mm:ss')
                dia2 = this.$moment(this.f2).format('YYYY-MM-DD 23:59:59')          
            }
            this.cargando = true
            axios
            .post(process.env.VUE_APP_API_URL + 'notadebito/boleta', {
                token: this.$store.getters.userToken,
                f1:dia1,
                f2:dia2,
                page: this.pactual,
                limit: this.limite,
                order: this.orden
            })
            .then(response => (
                this.debitnotes = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargando = false
                ))
            .catch(error => {})
        },
        sendMail: function (data) {
            this.modalsendnc = true
            this.previacorreo = true
            this.sendcorreo = true
            axios
            .post(process.env.VUE_APP_API_URL + 'notadebito/mail', {
                token: this.$store.getters.userToken,
                id: data.idNotaDebito,
                mail: this.recipients 
            })
            .then(response => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.modalsendnc = false,
                this.$snotify.success(response.data.msg, 'Exito')           
                ))
            .catch(error => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.modalsendnc = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        viewPdf: function (data) {
            this.pdfobject = ''
            this.cargandopdf2 = true
            axios
           .post(process.env.VUE_APP_API_URL + 'notadebito/pdf',{
               token: this.$store.getters.userToken,
               id: data.idNotaDebito
           }, config)
           .then(response => (
               this.pdfobject = response.data.base64,
               this.cargandopdf2 = false
           ))
           .catch(function (error){

           })
        },
        downloadPdf: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = data.serie + '-' + data.numero + '.pdf'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandopdf = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'notadebito/pdf',{
               token: this.$store.getters.userToken,
               id: data.idNotaDebito
           })
           .then(response => (
               file = 'data:application/pdf;base64,'+ response.data.base64,
               this.cargandopdf = false,               
               download(file, name,'application/pdf'),
               this.$swal.close()
           ))
            .catch(error => (
                this.$swal.close(),
                this.$snotify.error(error.response.data.response, 'Error'),
                this.cargandopdf = false
            ))         
        },
        downloadCdr: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = 'CDR-' + data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandocdr = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'notadebito/constancia',{
               token: this.$store.getters.userToken,
               id: data.idNotaDebito
           })
           .then(response => (
               file = 'data:application/zip;base64,'+ response.data.msg.xml,
               this.cargandocdr = false,               
               download(file, name,'application/zip'),
               this.$swal.close()
           ))
           .catch(function (error){
               
           })    
        },
        downloadXml: function (data){
            let name = data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/zip;base64,'+ data.xml           
            download(file, name,'application/zip');
        },
        estadoEmision: function (value) {
            this.spinoff = true
            axios
            .post(process.env.VUE_APP_API_URL + 'documento/motivorechazo', {
                token: this.$store.getters.userToken,
                serie: value.serie,
                numero: value.numero,
                tipo: '03'
            })
            .then(response => ( 
                this.descripcionRechazo = response.data.msg.descripcion,
                this.spinoff = false
            ))
            .catch(error => (
                this.$snotify.error(error.response.data, 'Error'),
                this.motivoRechazo = false,
                this.spinoff = false
            )) 
        },
        customFormatter(date) {
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        }
    }
}
</script>

<style>
    .espacio {
        margin-left: 15px;
    }
    .messageTipoNotaCredito {
        color: #8d8d8d;
        font-size: 11px;
    }
    .input-requerido {
        color:red;
        opacity: 0.7;
    }
</style>



